// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"src_pages_workflows_wrapper_tsx":"e2843f67","src_pages_snags_wrapper_tsx":"19a1c8dd","src_pages_workflows_bootstrap_tsx":"bf28fdbc","src_pages_snags_bootstrap_tsx":"37bfde6f"}[chunkId] + ".chunk.js";
};